<div mat-dialog-title class="flex items-center justify-center">
  {{ title }}
</div>

<mat-dialog-content class="flex flex-col text-center">
  {{ message }}
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    *ngIf="showCancel"
    mat-raised-button style="background-color: rgb(35, 43, 62);"
    color="primary"
    type="button"
    (click)="closeDialog(false)">
    {{ cancelText }}
  </button>

  <button
    *ngIf="showConfirm"
    mat-raised-button
    color="primary"
    (click)="closeDialog(true)">
    {{ confirmText }}
  </button>
</mat-dialog-actions>
